// Юридические документы партнёров. У партнёра поле убрано из кабинета —
// ссылку на легал каждого партнёра правит мета-админ здесь. Значение пишется
// в app_config.legal_url партнёра, мобилка его показывает в тексте согласия
// и в «О приложении» (пусто — ссылки скрыты). Каждый бренд (Evimiz, VashDom)
// сохраняет СВОЮ страницу.

import { useEffect, useState } from "react";
import { gql } from "../lib/gql";

type Partner = {
  id: string;
  code: string;
  companyName: string;
  legalUrl: string;
};

const LIST_QUERY = `
  query AdminPartnersLegal {
    adminPartners(limit: 500) {
      id
      code
      companyName
      legalUrl
    }
  }
`;

const SET_MUTATION = `
  mutation AdminSetPartnerLegalUrl($partnerId: ID!, $url: String!) {
    adminSetPartnerLegalUrl(partnerId: $partnerId, url: $url)
  }
`;

export function SettingsPage() {
  const [partners, setPartners] = useState<Partner[]>([]);
  const [draft, setDraft] = useState<Record<string, string>>({});
  const [savingId, setSavingId] = useState<string | null>(null);
  const [savedId, setSavedId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);

  async function load() {
    try {
      const data = await gql<{ adminPartners: Partner[] }>(LIST_QUERY);
      setPartners(data.adminPartners);
      setDraft(Object.fromEntries(data.adminPartners.map((p) => [p.id, p.legalUrl ?? ""])));
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setLoaded(true);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function save(p: Partner) {
    setSavingId(p.id);
    setSavedId(null);
    setError(null);
    try {
      const data = await gql<{ adminSetPartnerLegalUrl: string }>(SET_MUTATION, {
        partnerId: p.id,
        url: (draft[p.id] ?? "").trim(),
      });
      const saved = data.adminSetPartnerLegalUrl ?? "";
      setPartners((prev) => prev.map((x) => (x.id === p.id ? { ...x, legalUrl: saved } : x)));
      setDraft((d) => ({ ...d, [p.id]: saved }));
      setSavedId(p.id);
      setTimeout(() => setSavedId((cur) => (cur === p.id ? null : cur)), 3000);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setSavingId(null);
    }
  }

  return (
    <div className="page">
      <h2>Юридические документы партнёров</h2>
      <p style={{ color: "var(--muted, #888)", fontSize: 14, maxWidth: 720 }}>
        Ссылка на landing-page с Офертой, Политикой ПД и Лицензионным
        соглашением — отдельная для каждого партнёра (у партнёра в кабинете
        поле убрано). Мобилка показывает её в тексте согласия и в «О
        приложении». Пусто — ссылки скрыты.
      </p>
      {error && <div className="error">{error}</div>}
      {!loaded ? (
        <div>Загрузка…</div>
      ) : (
        <table className="data-table" style={{ width: "100%", maxWidth: 900 }}>
          <thead>
            <tr>
              <th style={{ textAlign: "left" }}>Партнёр</th>
              <th style={{ textAlign: "left" }}>Ссылка на юр.документы</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {partners.map((p) => {
              const dirty = (draft[p.id] ?? "") !== (p.legalUrl ?? "");
              return (
                <tr key={p.id}>
                  <td>
                    {p.companyName}
                    <br />
                    <span style={{ color: "var(--muted, #888)", fontSize: 12 }}>#{p.code}</span>
                  </td>
                  <td>
                    <input
                      type="url"
                      value={draft[p.id] ?? ""}
                      onChange={(e) => setDraft((d) => ({ ...d, [p.id]: e.target.value }))}
                      placeholder="https://…/legal"
                      style={{ width: "100%", padding: "6px 8px" }}
                    />
                  </td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <button onClick={() => save(p)} disabled={savingId === p.id || !dirty}>
                      {savingId === p.id ? "…" : "Сохранить"}
                    </button>
                    {savedId === p.id && (
                      <span style={{ color: "green", fontSize: 13, marginLeft: 8 }}>✓</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
